/**
 * @generated SignedSource<<52b317e10914132c19ef4ad2735c4806>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountDelegatedAuthsId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "environment",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationSetupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountDelegatedAuthsTPayload",
        "kind": "LinkedField",
        "name": "updateAccountDelegatedAuthsTByAccountDelegatedAuthsId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDelegatedAuthsT",
            "kind": "LinkedField",
            "name": "accountDelegatedAuthsT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationSetupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountDelegatedAuthsTPayload",
        "kind": "LinkedField",
        "name": "updateAccountDelegatedAuthsTByAccountDelegatedAuthsId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDelegatedAuthsT",
            "kind": "LinkedField",
            "name": "accountDelegatedAuthsT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f989f71ceeeaa826edf9b763c7c320ec",
    "id": null,
    "metadata": {},
    "name": "IntegrationSetupMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationSetupMutation(\n  $input: UpdateAccountDelegatedAuthsTByAccountDelegatedAuthsIdInput!\n) {\n  updateAccountDelegatedAuthsTByAccountDelegatedAuthsId(input: $input) {\n    accountDelegatedAuthsT {\n      accountDelegatedAuthsId\n      environment\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "aef2dd976ea1ad48e4c1fcd50358e91a";

module.exports = node;
